import { Container, Image, Layout, Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Vehicle } from '@esportal/portal-service';
import styled from 'styled-components';
import ModelTitleBackground from './model-title-background';
import { MyServicesAnimatedBackground } from './services-animated-background';

const ModelTitleBackgroundContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 0;
	pointer-events: none;
`;

const BackgroundWrapper = styled.div`
	position: relative;
	width: 100%;
	overflow: hidden;
`;

const StyledImage = styled(Image)`
	display: block;
	position: relative;
	transform: translateX(-50%);
	z-index: 0;
	width: 180%;
	left: 50%;
	margin-top: -5%;

	@media screen and (min-width: 560px) {
		width: 150%;
	}

	@media screen and (min-width: 960px) {
		width: 140%;
		margin-top: -11%;
	}

	@media screen and (min-width: 1280px) {
		width: 100%;
		margin-top: -9%;
	}
`;

const detectModel = (vehicleName: string): string => {
	//solamente para tener el alto de la imagen, pese a que no se vea
	if (!vehicleName)
		return 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/golf.png';

	const vehicleString = vehicleName.toLowerCase();

	if (vehicleString.includes('polo'))
		return 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/polo.png';
	if (vehicleString.includes('tiguan'))
		return 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/tiguan.png';
	if (vehicleString.includes('passat'))
		return 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/passat.png';
	if (vehicleString.includes('golf'))
		return 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/golf.png';

	return '';
};

export const ServicesHeader = ({ vehicle }: { vehicle: Vehicle }): React.ReactElement => {
	const fallbackImage = detectModel(vehicle.vgedModelGroup);

	// Lógica de prioridad de imágenes
	const actualImage = vehicle.mediaAssets?.Front_Center || vehicle.mediaAssets?.Front_Left || '';

	const imageSrc = actualImage || fallbackImage;

	// Imagen base para ocupar el espacio visual aunque esté oculta
	const placeholderImage =
		'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/img-coches/golf.png';

	return (
		<Container stretchContent wrap="always">
			<MyServicesAnimatedBackground />
			<Layout
				data-testid="myServices-modelTitleBackground-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 1 },
						{ name: 'a', columns: 22 },
						{ name: '.', columns: 1 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 3 },
						{ name: 'a', columns: 18 },
						{ name: '.', columns: 3 },
					],
				}}
				allowOverflowingContent
			>
				<BackgroundWrapper>
					<ModelTitleBackgroundContainer>
						<ModelTitleBackground text={vehicle.vgedModelGroup} />
					</ModelTitleBackgroundContainer>

					{imageSrc ? (
						<StyledImage src={imageSrc} alt={vehicle.vgedModelGroup} />
					) : (
						<StyledImage
							src={placeholderImage}
							alt=""
							style={{
								visibility: 'hidden',
								position: 'static',
								transform: 'none',
								left: '0',
								marginTop: '0',
							}}
						/>
					)}
				</BackgroundWrapper>
			</Layout>
		</Container>
	);
};
